import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollegialLending = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22 15.5C22 19 18.87 22 15 22L16.05 20.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 9C2 5.13 5.13 2 9 2L7.95001 3.75",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.96736 15.16C5.90736 15.15 5.83736 15.15 5.77736 15.16C4.39736 15.11 3.29736 13.98 3.29736 12.58C3.29736 11.15 4.44736 10 5.87736 10C7.30736 10 8.45736 11.16 8.45736 12.58C8.44736 13.98 7.34736 15.12 5.96736 15.16Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.0575 17.81C1.6475 18.75 1.6475 20.29 3.0575 21.23C4.6575 22.3 7.2775 22.3 8.8775 21.23C10.2875 20.29 10.2875 18.75 8.8775 17.81C7.2875 16.75 4.6575 16.75 3.0575 17.81Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9674 7.16C17.9074 7.15 17.8374 7.15 17.7774 7.16C16.3974 7.11 15.2974 5.98 15.2974 4.58C15.2974 3.15 16.4474 2 17.8774 2C19.3074 2 20.4574 3.16 20.4574 4.58C20.4474 5.98 19.3474 7.12 17.9674 7.16Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0575 9.78499C13.6475 10.725 13.6475 12.265 15.0575 13.205C16.6575 14.275 19.2775 14.275 20.8775 13.205C22.2875 12.265 22.2875 10.725 20.8775 9.78499C19.2875 8.72499 16.6575 8.72499 15.0575 9.78499Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCollegialLending;
